import React from 'react';
import { get } from 'lodash';
import { Line } from '../../graphs';
import { HalfPagePie } from './half-page-pie';
import { getSelectedParcelsTitle, parseLineData } from './selectors';
import { Loading } from './loading';

export const LineGraphs = ({ city, reportContents, prop }) => {
  const graph = reportContents.graphs[prop.graph];
  const cityGraph = reportContents.graphs[`${prop.graph}_city`];
  const showCity = !!prop.compare;

  if (!graph || (!cityGraph && showCity)) {
    return <Loading key={`${prop.column}-${prop.label}`} />;
  }
  let layerValuesByKey;
  let cityValuesByKey;
  if (typeof prop.useRatio === 'boolean' && !prop.useRatio) {
    layerValuesByKey = parseLineData(graph, cityGraph, prop.useRatio);
    cityValuesByKey = showCity ? parseLineData(cityGraph, graph, prop.useRatio) : null;
  } else {
    layerValuesByKey = parseLineData(graph, cityGraph);
    cityValuesByKey = showCity ? parseLineData(cityGraph, graph) : null;
  }
  const { map } = prop;

  const exclude = [
    ...(prop.exclude || []),
    ...[undefined, null, 'undefined', 'null'],
  ];

  if (map) {
    layerValuesByKey = Object.keys(layerValuesByKey).reduce((acc, key) => {
      if (exclude.includes(key)) return acc;
      acc[map[key]] = layerValuesByKey[key];
      return acc;
    }, {});

    if (showCity) {
      cityValuesByKey = Object.keys(cityValuesByKey).reduce((acc, key) => {
        if (exclude.includes(key)) return acc;
        acc[map[key]] = cityValuesByKey[key];
        return acc;
      }, {});
    }
  }

  const graphs = Object.keys(layerValuesByKey).map((key) => {
    if (exclude.includes(key)) return null;
    const data = [
      {
        id: getSelectedParcelsTitle(reportContents, prop),
        data: layerValuesByKey[key] || [],
      },
    ];
    if (showCity) {
      data.push({
        id: city,
        data: cityValuesByKey[key] || [],
      });
    }

    return (
      <div
        {...{ 'data-test': 'line-graph' }}
        key={`${prop.column}-${prop.label}-${key}`}
        style={{
          height: 300,
          width: '50%',
          minWidth: 300,
        }}
        className="break-after-while-printing"
      >
        <span>{prop.title || key}</span>
        <Line
          hideLegend={prop.hideLegend}
          yLabel={prop.unit || 'Percent'}
          xLabel="Time"
          data={data}
        />
      </div>
    );
  });

  const pieCharts = !get(prop, 'options.showPieChart')
    ? []
    : [
      <HalfPagePie
        title={getSelectedParcelsTitle(reportContents, prop)}
        prop={prop}
        valuesByKey={layerValuesByKey}
        key={`${prop.column}-${prop.label}-layer`}
        className="break-after-while-printing"
      />,
      <HalfPagePie
        title={city}
        prop={prop}
        valuesByKey={cityValuesByKey}
        key={`${prop.column}-${prop.label}-city`}
        className="break-after-while-printing"
      />,
    ];
  return [...pieCharts, ...graphs];
};
